import { TableCell, Tooltip } from '@mui/material';
import React from 'react';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import IconWrapper from './styles/IconWrapper';

type DeleteButtonProps = {
  onClick: () => void;
  isPause: boolean;
};

function PauseButton({ onClick, isPause }: DeleteButtonProps): JSX.Element {
  return (
    <TableCell onClick={onClick}>
      <Tooltip title={isPause ? 'Возобновить' : 'Пауза'} arrow placement="right">
        <IconWrapper>{isPause ? <PlayArrowIcon /> : <PauseIcon />}</IconWrapper>
      </Tooltip>
    </TableCell>
  );
}

export default PauseButton;
